import React, { useEffect, useState } from "react";
import { Activity, RefreshCw, Info, AlertTriangle } from "lucide-react";
import { aiApi } from "../lib/ledgerApi";

const SEV_ICON = {
  warn: AlertTriangle,
  info: Info,
};
const SEV_COLOR = {
  warn: "text-amber-600 dark:text-amber-400 border-amber-500/30 bg-amber-500/5",
  info: "text-status-info border-status-info/30 bg-status-info/5",
};

export default function InsightsCard() {
  const [data, setData] = useState({ insights: [], updated_at: null });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      setData(await aiApi.myInsights());
    } catch {}
  };

  const refresh = async () => {
    setBusy(true);
    try {
      setData(await aiApi.refreshInsights());
    } catch {} finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="border border-border rounded-sm bg-card p-5" data-testid="insights-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Activity className="w-4 h-4 text-muted-foreground" strokeWidth={1.5} />
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">AI insights</div>
        </div>
        <button
          onClick={refresh}
          data-testid="insights-refresh"
          disabled={busy}
          className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground inline-flex items-center gap-1"
        >
          <RefreshCw className={`w-3 h-3 ${busy ? "animate-spin" : ""}`} strokeWidth={1.5} /> Refresh
        </button>
      </div>
      {data.insights.length === 0 && (
        <div className="text-xs text-muted-foreground py-3">
          No anomalies detected over the last 24 hours.
        </div>
      )}
      <ul className="space-y-2">
        {data.insights.map((ins, i) => {
          const Icon = SEV_ICON[ins.severity] || Info;
          return (
            <li
              key={i}
              data-testid={`insight-${ins.code}`}
              className={`p-3 border rounded-sm flex items-start gap-2 ${SEV_COLOR[ins.severity] || ""}`}
            >
              <Icon className="w-3.5 h-3.5 mt-0.5 shrink-0" strokeWidth={1.5} />
              <div className="text-xs">
                <div className="font-medium">{ins.title}</div>
                <div className="text-muted-foreground mt-0.5">{ins.description}</div>
              </div>
            </li>
          );
        })}
      </ul>
      {data.updated_at && (
        <div className="text-[10px] text-muted-foreground font-mono mt-3 pt-3 border-t border-border">
          updated {new Date(data.updated_at).toLocaleTimeString()}
        </div>
      )}
    </div>
  );
}
